<template>
  <div class="content-page">
    <div class="page-title flex-center-start">
      <img :src="backUrl" alt="" @click="back">
      {{ $t('fu-wu-tiao-kuan') }} </div>

    <div class="agreement-content" v-html="content"></div>
  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      backUrl: require('../../assets/imgs/icon-back.png')
    }
  },
  computed: {
    appName() {
      return this.$store.state.appName
    },
    content() {
      const currentDate = new Date().toISOString().split('T')[0]
      const appName = this.appName || 'CoinOcean'

      return `
        <div class="terms-section">
          <h2>Terms of Service</h2>
          <p class="last-updated">Last Updated: ${currentDate}</p>

          <div class="terms-item">
            <h3>1. Introduction</h3>
            <p>Welcome to ${appName}, a digital asset trading platform. These Terms of Service ("Terms") govern your access to and use of our website, mobile application, and services. By accessing or using our services, you agree to be bound by these Terms. If you do not agree with any part of these Terms, you may not access or use our services.</p>
          </div>

          <div class="terms-item">
            <h3>2. Registration and Account Security</h3>
            <p>2.1 To use our services, you must register for an account and provide accurate and complete information.</p>
            <p>2.2 You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>
            <p>2.3 You must immediately notify us of any unauthorized use of your account or any other breach of security.</p>
            <p>2.4 We reserve the right to suspend, disable, or terminate your account if we believe that you have violated these Terms or if we determine that your actions may cause legal liability for you, other users, or us.</p>
          </div>

          <div class="terms-item">
            <h3>3. KYC and AML Compliance</h3>
            <p>3.1 We are committed to complying with Know Your Customer (KYC) and Anti-Money Laundering (AML) regulations.</p>
            <p>3.2 You may be required to complete identity verification procedures before you can use certain features of our services or before certain limits can be lifted.</p>
            <p>3.3 You agree to provide accurate, current, and complete information for all verification procedures.</p>
            <p>3.4 We reserve the right to refuse registration, suspend or terminate accounts, or limit access to our services if KYC/AML procedures are not completed to our satisfaction.</p>
          </div>

          <div class="terms-item">
            <h3>4. Trading Rules</h3>
            <p>4.1 You are responsible for understanding the risks involved in digital asset trading.</p>
            <p>4.2 All trades are final and cannot be reversed once confirmed.</p>
            <p>4.3 We reserve the right to suspend trading, cancel orders, or roll back transactions in case of market anomalies, technical issues, or suspected market manipulation.</p>
            <p>4.4 Trading fees apply to all transactions as specified on our Fee Schedule, which may be updated from time to time.</p>
          </div>

          <div class="terms-item">
            <h3>5. Deposits and Withdrawals</h3>
            <p>5.1 You are responsible for ensuring that deposit addresses are correct.</p>
            <p>5.2 Deposits may require a certain number of network confirmations before being credited to your account.</p>
            <p>5.3 Withdrawal requests are subject to processing times and security checks.</p>
            <p>5.4 We reserve the right to delay or reject deposit or withdrawal requests if we suspect fraudulent activity or if there are compliance concerns.</p>
          </div>

          <div class="terms-item">
            <h3>6. Prohibited Activities</h3>
            <p>You agree not to engage in any of the following prohibited activities:</p>
            <ul>
              <li>Violating any laws, regulations, or third-party rights</li>
              <li>Market manipulation or fraudulent activities</li>
              <li>Unauthorized access to our systems or other users' accounts</li>
              <li>Using our services to launder money or finance terrorism</li>
              <li>Using automated systems or software to extract data from our platform without our prior written consent</li>
              <li>Any activity that disrupts or interferes with the normal operation of our services</li>
            </ul>
          </div>

          <div class="terms-item">
            <h3>7. Limitation of Liability</h3>
            <p>7.1 Our services are provided on an "as is" and "as available" basis without any warranties of any kind.</p>
            <p>7.2 We are not responsible for any losses or damages resulting from:</p>
            <ul>
              <li>Your failure to maintain the security of your account credentials</li>
              <li>Fluctuations in digital asset prices</li>
              <li>System downtime, network failures, or other technical issues</li>
              <li>Actions of third parties, including other users</li>
              <li>Regulatory actions or changes in laws affecting digital assets</li>
            </ul>
            <p>7.3 In no event shall our total liability to you for all claims exceed the amount you have paid to us in fees during the six months preceding the claim.</p>
          </div>

          <div class="terms-item">
            <h3>8. Changes to Terms</h3>
            <p>8.1 We reserve the right to modify these Terms at any time.</p>
            <p>8.2 We will notify you of material changes through our website or by sending an email to the address associated with your account.</p>
            <p>8.3 Your continued use of our services after such modifications constitutes your acceptance of the updated Terms.</p>
          </div>

          <div class="terms-item">
            <h3>9. Termination</h3>
            <p>9.1 You may terminate these Terms at any time by closing your account and ceasing to use our services.</p>
            <p>9.2 We may terminate or suspend your access to our services at any time, with or without cause, and without notice.</p>
            <p>9.3 Upon termination, any provisions of these Terms that by their nature should survive termination shall remain in effect.</p>
          </div>

          <div class="terms-item">
            <h3>10. Governing Law</h3>
            <p>These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which our company is incorporated, without regard to its conflict of law provisions.</p>
          </div>
        </div>
      `
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    toRefresh() {
      this.$toast.success(this.i18n.t('about.label3'))
    }
  }
}
</script>
<style scoped>
.agreement-content {
  padding: 15px;
  color: #333;
  line-height: 1.6;
}

.terms-section {
  max-width: 800px;
  margin: 0 auto;
}

.terms-section h2 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #0d47a1;
}

.last-updated {
  color: #666;
  font-style: italic;
  margin-bottom: 20px;
}

.terms-item {
  margin-bottom: 25px;
}

.terms-item h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #0d47a1;
}

.terms-item p {
  margin-bottom: 10px;
}

.terms-item ul {
  padding-left: 20px;
  margin-bottom: 10px;
}

.terms-item li {
  margin-bottom: 5px;
}
</style>